import {
  Box,
  Center,
  SimpleGrid,
  Text
} from "@chakra-ui/react";
import CardScope from "./cardScope";
import SectionHeading from "./sectionHeading";
import LineSection from "../lineSection";
import Lang from "../../Lang";

export default function Scope() {
  return (
    <>
      <LineSection />

      <Box
        color='white'
        bg="black"
        pb={10}
        pt={14}
      >

        <Center>
          <Box
            w={{ base: "full", md: "full", xl: "8xl" }}
          >
            <Box
              pb={{ base: 10, md:20 }}
            >
              <SectionHeading
                title="Scope"
                align={"center"}
              />
            </Box>

            <Center>
              <SimpleGrid
                columns={{ base: 1, md: 2, lg: 2, xl: 2 }}
                spacing={20}
                alignItems={"flex-end"}

              >
                <CardScope
                  image="img/beautiful-curly-female-freelancer-with-cute-manicure-using-laptop-smiling-indoor-portrait-blonde-secretary-sitting-beside-african-coworker-blue-shirt.webp"
                  w={{ base: 300, md: 320, lg: "570px" }}
                  h={{ base: 400, md: 500, lg: "727px" }}
              />
                <Box
                  display={{ base: "none", md: "flex" }}
                >
                  <CardScope
                    image="img/speaker-stage-front-room-with-rear-view-audience-put-hand-up-acton.webp"
                    w={{ base: 300, md: 320, lg: "570px" }}
                    h={{ base: 400, md: 500, lg: "627px" }}
                    />
                </Box>
              </SimpleGrid>
            </Center>

            <Center>
              <Box
                w={{ base: "xl", md: "4xl", xl: "6xl" }}
              >
                <Text
                  pt={{ base: 10, md: 20, xl: 20 }}
                  pb={{ base: 6, md: 15, xl: 20 }}
                  px={{ base: 4, md: 6 }}
                  fontSize={{ base: "1.3em", md: "1.5em", lg:"1.7",xl:"2em" }}
                  className="barlow-regular"
                >
                  <Lang text="Undergraduate Colombian students enrolled in data science, data engineer, artificial intelligence or similar in an accredited university, with good grades and belonging to a vulnerable population." />
                </Text>
              </Box>
            </Center>
          </Box>
        </Center>

      </Box>
    </>
  );
}